export default __webpack_public_path__ + "static/img/bg@2x.a95b0b.png";